import constants from 'constants/index'

const getIndexByTag = (tag) => {
  const {
    VISUAL_IDENTITY_TAG,
    COMPANY_SITE_TAG,
    COOKIE_BANNER_TAG,
    DPO_APPOINTMENT_TAG,
    COMPANY_DOCUMENTS_TAG,
    CONCLUSION_TAG,
    STEP_VISUAL_IDENTITY,
    STEP_SITE,
    STEP_COOKIE,
    STEP_DPO_APPOINTMENT,
    STEP_DOCS,
    STEP_CONCLUSION,
  } = constants.userTrailSteps

  switch (tag) {
    case VISUAL_IDENTITY_TAG:
      return STEP_VISUAL_IDENTITY
    case COMPANY_SITE_TAG:
      return STEP_SITE
    case COOKIE_BANNER_TAG:
      return STEP_COOKIE
    case DPO_APPOINTMENT_TAG:
      return STEP_DPO_APPOINTMENT
    case COMPANY_DOCUMENTS_TAG:
      return STEP_DOCS
    case CONCLUSION_TAG:
      return STEP_CONCLUSION
    default:
      return STEP_VISUAL_IDENTITY
  }
}

export default getIndexByTag
